<template>
  <div class="index-page-bg-fff">
    <!-- 代理商小程序通知 -->
    <div class="img_box" @click="() => (showApplet = true)" v-if="isOem">
      <img src="../../../static/home/img_banner_2x.png" alt="" />
      <div class="btnFullColor">
        立即查看
      </div>
    </div>

    <!--代理费率 & 消息通知-->
    <div class="tab-notice-part">
      <div class="left-tab-part">
        <!-- 阶梯费率展示 -->
        <div class="title">
          <span class="tab-text notice-text">代理费率</span>
        </div>

        <div class="rate_range">
          <RateRange
            :isSmallScreen="isSmallScreen"
            :data="rateRangeList"
            :issueData="mockObject"
            :isShow="isShow"
            :marginBottom="'32px'"
          ></RateRange>
        </div>
      </div>

      <!-- 消息通知 -->
      <notice-list></notice-list>
    </div>
    <span class="margin-bg"></span>

    <!-- 数据 5.14 -->
    <div class="tab-notice-part">
      <div class="left-tab-part">
        <div class="title">
          <span class="tab-text notice-text">交易数据</span>
        </div>

        <div class="data-box">
          <div class="data-item">
            <div class="">
              <span>今日交易总金额：</span>
              <span class="amount">{{ resData2.todayTransaction }}</span>
            </div>
            <div class="">
              <span>今日佣金：</span>
              <span class="amount">{{ resData2.todayBrokerageAmount }}</span>
            </div>
          </div>

          <div class="data-item">
            <div class="">
              <span>当月交易总金额：</span>
              <span class="amount">{{ resData2.thisMonthTransaction }}</span>
            </div>
            <div class="">
              <span>当月实时佣金：</span>
              <span class="amount">{{
                resData2.thisMonthBrokerageAmount
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="right-notice-part">
        <div class="title">
          <span class="tab-text notice-text">交易数据分析</span>
        </div>

        <div class="data-box">
          <div class="data-item">
            <div class="" @click="jumpToPage('monthOnMonthStatis')">
              <span>上月交易总额：</span>
              <span class="amount">{{ resData2.lastMonthTransaction }}</span>
            </div>
          </div>

          <div class="data-item">
            <div class="" @click="jumpToPage('monthOnMonthStatis')">
              <span>月交易额环比增长：</span>
              <span class="amount black">{{ resData2.transactionRate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="margin-bg"></span>

    <!-- 商户信息 5.14 -->
    <div class="merchant-part clearfix">
      <div class="title">
        <span class="tab-text notice-text">商户信息</span>
      </div>
      <div class="merchant-info-box">
        <div class="merchant-item">
          <div class="item-title">未产生交易商户</div>
          <div class="item-content">
            <div class="single-item" @click="jumpToMerList('/coopList', 1)">
              <div class="circle"><span>30天</span></div>
              <div class="text">
                <span>无交易商户：</span>
                <span>{{ resData.batchAgentCount1 }}个</span>
              </div>
            </div>
            <div class="single-item" @click="jumpToMerList('/coopList', 2)">
              <div class="circle"><span>60天</span></div>
              <div class="text">
                <span>无交易商户：</span>
                <span>{{ resData.batchAgentCount2 }}个</span>
              </div>
            </div>
            <div class="single-item" @click="jumpToMerList('/coopList', 3)">
              <div class="circle"><span>90天</span></div>
              <div class="text">
                <span>无交易商户：</span>
                <span>{{ resData.batchAgentCount3 }}个</span>
              </div>
            </div>
          </div>
        </div>
        <div class="merchant-item">
          <div class="item-title">未开票商户</div>
          <div class="item-content">
            <div class="single-item" @click="jumpToMerList('/coopList', 4)">
              <div class="circle"><span>30天</span></div>
              <div class="text">
                <span>未开票商户：</span>
                <span>{{ resData2.notInvoice4thirty }}个</span>
              </div>
            </div>
            <div class="single-item" @click="jumpToMerList('/coopList', 5)">
              <div class="circle"><span>60天</span></div>
              <div class="text">
                <span>未开票商户：</span>
                <span>{{ resData2.notInvoice4Sixty }}个</span>
              </div>
            </div>
            <div class="single-item" @click="jumpToMerList('/coopList', 6)">
              <div class="circle"><span>90天</span></div>
              <div class="text">
                <span>未开票商户：</span>
                <span>{{ resData2.notInvoice4Ninety }}个</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="margin-bg"></span>

    <!-- 佣金明细  5.14 -->
    <div class="desc-part">
      <div class="title">
        <span class="tab-text notice-text">佣金明细</span>
        <span
          class="notice-more"
          @click="jumpToPage('/AgentTransactionStatistics')"
        >
          查看更多<i class="el-icon-d-arrow-right"></i>
        </span>
      </div>
      <div class="list-box">
        <el-table :data="resDescList">
          <el-table-column label="月份" prop="occurMonth"> </el-table-column>

          <el-table-column
            label="交易总额"
            prop="distributeSuccessAmount"
          ></el-table-column>

          <el-table-column
            label="实际结算佣金"
            prop="batchBrokerage"
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 代理商小程序上线通知 -->
    <div
      class="dialog_mask"
      v-if="showApplet"
      @click="() => (showApplet = false)"
    ></div>
    <div class="imgBox_dialog" v-if="showApplet">
      <span class="close" @click="() => (showApplet = false)">
        <img src="../../../static/home/img_close.png" alt="" />
      </span>
      <img
        class="bgClose"
        src="../../../static/home/img_bg_dl.png"
        @click="() => (showApplet = true)"
        alt=""
      />
      <div class="btn_know" @click="() => (showApplet = false)">我知道了</div>
    </div>
  </div>
</template>

<script>
import {
  fenToYuan,
  formatDate,
  isNull,
  fenToWanNoFixed
} from "../../filters/filters";
import { HTTP_CODE } from "../../../build/axios_constants";
import costRateTable from "../../components/costRateTable";
import noticeList from "../../components/notice-list";
import RateRange from "../../components/rateRange.vue";

export default {
  name: "index-agent",
  components: {
    "cost-rate-table": costRateTable,
    "notice-list": noticeList,
    RateRange
  },

  computed: {},

  data() {
    return {
      showApplet: false,
      resNoticeList: [],
      noticeListEmpty: true,
      resData: {},
      resData2: {},
      dateParam: "", // 日期
      resDescList: [], // 佣金明细列表
      isOem: [
        "bweb.hvyogo.com",
        "web.hvyogo.com",
        "local-web.hvyogo.com"
      ].includes(window.location.hostname),
      rateRangeList: [],
      mockObject: {},
      isSmallScreen: false,
      isShow: false // 代理不显示上月下发总额
    };
  },

  created() {
    // 获取今天的日期
    let today = formatDate(new Date());
    this.dateParam = today;
  },

  beforeCreate() {
    console.log("代理 beforeCreate");
  },

  beforeDestroy() {
    console.log("代理 beforeDestroy");
    window.removeEventListener("resize", this.modifyWidth);
  },

  mounted() {
    this.modifyWidth();
    window.addEventListener("resize", this.modifyWidth);
    this.xhrGetIndexData(); // 代理费率
    this.xhrNoticeList(); // 消息通知
    this.xhrIndexAgentData2(); // 数据
    this.xhrAgentCommissionDesc(); // 代理佣金明细
    this.xhrQueryPhaseRule();
  },

  methods: {
    // xhr -- 首页阶梯费率展示
    xhrQueryPhaseRule() {
      this.$http.queryPhaseRule({}).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          if (!!res.data) {
            this.rateRangeList = !!res.data.cooperatorPhaseRules
              ? res.data.cooperatorPhaseRules.map(it => {
                  // 处理成无穷大
                  it.rateRange =
                    fenToWanNoFixed(it.lowerLimitAmount) +
                    "～" +
                    fenToWanNoFixed(it.upperLimitAmount);
                  return it;
                })
              : [];
            this.mockObject = {
              customerCurrentMonthDistributeAmount: fenToYuan(
                res.data.customerCurrentMonthDistributeAmount
              ),
              customerLastMonthDistributeAmount: fenToYuan(
                res.data.customerLastMonthDistributeAmount
              )
            };
          }
        }
      });
    },
    // xhr -- 代理佣金明细  5.14
    xhrAgentCommissionDesc() {
      this.$http.getIndexAgentCommissionDesc().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resDescList = res.data.list;
          for (let item of this.resDescList) {
            item.distributeSuccessAmount = fenToYuan(
              item.distributeSuccessAmount
            );
            item.batchBrokerage = fenToYuan(item.batchBrokerage);
          }
        }
      });
    },

    // xhr -- 数据 交易数据+交易数据分析+未开票商户   5.14
    xhrIndexAgentData2() {
      this.$http.getIndexAgentData().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resData2 = res.data;
          this.resData2.todayTransaction = fenToYuan(res.data.todayTransaction);
          this.resData2.thisMonthTransaction = fenToYuan(
            res.data.thisMonthTransaction
          );
          this.resData2.todayBrokerageAmount = fenToYuan(
            res.data.todayBrokerageAmount
          );
          this.resData2.thisMonthBrokerageAmount = fenToYuan(
            res.data.thisMonthBrokerageAmount
          );
          this.resData2.lastMonthTransaction = fenToYuan(
            res.data.lastMonthTransaction
          );
        }
      });
    },

    // xhr -- 首页数据 - 代理费率 + 未产生交易商户
    xhrGetIndexData() {
      let param = {
        beginTime: this.dateParam,
        endTime: this.dateParam
      };
      this.$http.getIndexDataMerchantAndAgent(param).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resData = res.data;
        }
      });
    },

    // 根据屏幕尺寸判断费率展示样式
    modifyWidth() {
      const clientWidth = document.body.clientWidth;
      if (clientWidth < 1600) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
    },

    // 跳转页面
    jumpToPage(path) {
      this.$router.push({ path: path });
    },

    // 跳转商户列表
    jumpToMerList(path, param) {
      this.$router.push({ path: path, query: { dateParam: param } });
    },

    // 跳转商户交易统计页面
    jumpToStatic(path) {
      this.$router.push({ path: path, query: { dateParam: this.dateParam } });
    },

    // 跳转消息页面
    jumpToDetailPage(path, id) {
      this.$router.push({ path: path, query: { noticeId: id } });
    },

    // xhr -- 消息列表
    xhrNoticeList() {
      let params = {
        pageNum: 1,
        pageSize: 20
      };
      this.$http.postNoticeList(params).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          for (let item of res.data.list) {
            item.createTime = item.createTime.substr(5, 5);
          }

          this.resNoticeList = res.data.list;

          if (this.resNoticeList.length === 0) {
            this.noticeListEmpty = true;
          } else {
            this.noticeListEmpty = false;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.left-tab-part {
  background-color: #fff;
  // height: 400px;
  border-radius: 2px;
}

.tab-notice-part {
  display: flex;
  justify-content: space-between;

  .left-tab-part {
    width: 63%;
    .title {
      width: 100%;
    }

    // 交易数据
    .data-box {
      padding: 0 32px;
      .data-item {
        display: flex;
        justify-content: flex-start;
        margin: 24px 0 0;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 24px;
        div {
          width: 50%;
          span {
            display: block;
            font-size: 14px;
          }
          .amount {
            color: #ff943e;
            font-size: 20px;
            height: 28px;
            line-height: 28px;
            margin-top: 10px;
          }
        }
      }
      .data-item:last-child {
        border-bottom: none;
      }
    }
  }

  .right-notice-part {
    width: 35%;
    .title {
      width: 100%;
    }

    .notice-list {
      padding: 0 32px;
      margin-top: 24px;
      margin-bottom: 24px;
      overflow-y: hidden;
      max-height: 296px;

      .empty-text {
        font-size: 14px;
        width: 100%;
        display: inline-block;
        height: 20px;
        text-align: center;
      }

      .notice-item {
        font-size: 14px;
        margin-bottom: 14px;
        cursor: pointer;
        .notice-title {
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 20px;
          line-height: 20px;
          margin-bottom: 8px;
          div.left-div {
            width: 85%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            span {
              height: 20px;
              line-height: 20px;
              margin-left: 8px;
            }
            img {
              vertical-align: sub;
            }
          }

          span {
            text-align: right;
            width: 48px;
            margin-left: 8px;
            color: #8c8c8c;
          }
        }

        .notice-detail {
          height: 20px;
          margin-left: 28px;
          padding-right: 32px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.left-tab-part,
.right-notice-part,
.merchant-part,
.desc-part {
  background-color: #ffffff;
  // height: 400px;
  border-radius: 2px;
}

.title {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
  box-sizing: border-box;
  .tab-text {
    color: #8c8c8c;
    text-align: left;
    font-size: 16px;
    width: 100px;
    display: inline-block;
    margin-left: 40px;
    cursor: pointer;
  }
  .active {
    color: #272727;
    border-bottom: 4px solid #1a85ff;
  }
  .notice-text {
    color: #272727;
    margin-left: 32px;
    cursor: auto;
  }
  .notice-more {
    margin-right: 32px;
    font-size: 14px;
    color: #1985ff;
    float: right;
    cursor: pointer;
  }

  .more-text {
    color: #272727;
    margin-left: 32px;
    width: 112px;
  }
}

// 交易数据
.data-box {
  padding: 0 32px;
  .data-item {
    display: flex;
    justify-content: flex-start;
    margin: 24px 0 0;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 24px;
    div {
      width: 50%;
      span {
        display: block;
        font-size: 14px;
      }
      .amount {
        color: #ff943e;
        font-size: 20px;
        line-height: 28px;
        height: 28px;
        margin-top: 10px;
        font-weight: 500;
      }
      .black {
        color: #272727;
      }
    }
  }
  .data-item:last-child {
    border-bottom: none;
  }
}

// 商户信息
.merchant-part {
  width: 100%;
  .merchant-info-box {
    padding: 0 32px;
    .merchant-item {
      padding-bottom: 30px;
      border-bottom: 1px solid #e5e5e5;
      .item-title {
        font-weight: 900;
        color: #272727;
        margin: 24px 0;
      }
      .item-content {
        display: flex;
        justify-content: flex-start;
        .single-item {
          width: calc(100% / 3);
          display: inline-flex;
          align-items: center;
          .text {
            span {
              display: block;
            }
            span:last-child {
              font-size: 20px;
              font-weight: 500;
              margin-top: 8px;
            }
          }
          .circle {
            margin-right: 16px;
            width: 50px;
            height: 50px;
            border: 1px solid #1985ff;
            color: #1985ff;
            border-radius: 50%;
            text-align: center;
            span {
              display: inline-block;
              margin-top: 14px;
            }
          }
        }
      }
    }
    .merchant-item:last-child {
      border-bottom: none;
    }
  }
}

// 佣金明细
.desc-part {
  width: 100%;
  .list-box {
    padding: 24px 32px;
  }
}

.img_box {
  cursor: pointer;
  width: 100%;
  height: 80px;
  margin-bottom: 24px;
  position: relative;
  background: linear-gradient(166deg, #fffffb 0%, #d2eaff 100%);
  border-radius: 8px;
  img {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    // width: 100%;
    height: 100%;
  }
  .btnFullColor {
    width: 125px;
    height: 32px;
    background: #1985ff;
    box-shadow: 0px 2px 4px 0px rgba(49, 151, 244, 0.5);
    border-radius: 4px;
    position: absolute;
    top: 50%;
    right: 50px;
    transform: translate(0, -50%);
  }
}

// 遮罩
.dialog_mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2006;
}

.imgBox_dialog {
  width: 736px;
  // height: 375px;
  height: calc(636px / 375px);
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2007;
  .bgClose {
    display: block;
    width: 100%;
    height: 100%;
  }
  .close {
    cursor: pointer;
    display: block;
    width: 16px;
    height: 16px;
    position: absolute;
    right: 22px;
    top: 22px;
    z-index: 100;
    img {
      position: absolute;
      z-index: 99;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .btn_know {
    width: 156px;
    cursor: pointer;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background: #1985ff;
    box-shadow: 0px 2px 4px 0px rgba(49, 151, 244, 0.5);
    border-radius: 4px;
    color: #fff;
    position: absolute;
    left: 100px;
    bottom: 49px;
  }
}
.rate_range {
  margin: 16px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/indexStatistic/indexAgent.vue